import { array, mixed, object, string } from 'yup';

import { TWorkplaceType } from '../types';

export const EMPLOYMENT_TYPE_OPTIONS = [
  { id: 'fullTime', label: 'Full time', value: 'fullTime' },
  { id: 'partTime', label: 'Part time', value: 'partTime' },
  { id: 'contract', label: 'Contract', value: 'contract' },
  { id: 'freelance', label: 'Freelance', value: 'freelance' },
  { id: 'internship', label: 'Internship', value: 'internship' },
  { id: 'temporary', label: 'Temporary', value: 'temporary' },
];

export const CURRENCY_OPTIONS = [
  { id: 'EUR', label: 'EUR', value: 'EUR' },
  { id: 'GBP', label: 'GBP', value: 'GBP' },
  { id: 'USD', label: 'USD', value: 'USD' },
  { id: 'AED', label: 'AED', value: 'AED' },
  { id: 'AFN', label: 'AFN', value: 'AFN' },
  { id: 'ALL', label: 'ALL', value: 'ALL' },
  { id: 'AMD', label: 'AMD', value: 'AMD' },
  { id: 'ANG', label: 'ANG', value: 'ANG' },
  { id: 'AOA', label: 'AOA', value: 'AOA' },
  { id: 'ARS', label: 'ARS', value: 'ARS' },
  { id: 'AUD', label: 'AUD', value: 'AUD' },
  { id: 'AWG', label: 'AWG', value: 'AWG' },
  { id: 'AZN', label: 'AZN', value: 'AZN' },
  { id: 'BAM', label: 'BAM', value: 'BAM' },
  { id: 'BBD', label: 'BBD', value: 'BBD' },
  { id: 'BDT', label: 'BDT', value: 'BDT' },
  { id: 'BGN', label: 'BGN', value: 'BGN' },
  { id: 'BHD', label: 'BHD', value: 'BHD' },
  { id: 'BIF', label: 'BIF', value: 'BIF' },
  { id: 'BMD', label: 'BMD', value: 'BMD' },
  { id: 'BND', label: 'BND', value: 'BND' },
  { id: 'BOB', label: 'BOB', value: 'BOB' },
  { id: 'BRL', label: 'BRL', value: 'BRL' },
  { id: 'BSD', label: 'BSD', value: 'BSD' },
  { id: 'BTN', label: 'BTN', value: 'BTN' },
  { id: 'BWP', label: 'BWP', value: 'BWP' },
  { id: 'BYN', label: 'BYN', value: 'BYN' },
  { id: 'BZD', label: 'BZD', value: 'BZD' },
  { id: 'CAD', label: 'CAD', value: 'CAD' },
  { id: 'CDF', label: 'CDF', value: 'CDF' },
  { id: 'CHF', label: 'CHF', value: 'CHF' },
  { id: 'CLP', label: 'CLP', value: 'CLP' },
  { id: 'CNY', label: 'CNY', value: 'CNY' },
  { id: 'COP', label: 'COP', value: 'COP' },
  { id: 'CRC', label: 'CRC', value: 'CRC' },
  { id: 'CUC', label: 'CUC', value: 'CUC' },
  { id: 'CUP', label: 'CUP', value: 'CUP' },
  { id: 'CVE', label: 'CVE', value: 'CVE' },
  { id: 'CZK', label: 'CZK', value: 'CZK' },
  { id: 'DJF', label: 'DJF', value: 'DJF' },
  { id: 'DKK', label: 'DKK', value: 'DKK' },
  { id: 'DOP', label: 'DOP', value: 'DOP' },
  { id: 'DZD', label: 'DZD', value: 'DZD' },
  { id: 'EGP', label: 'EGP', value: 'EGP' },
  { id: 'ERN', label: 'ERN', value: 'ERN' },
  { id: 'ETB', label: 'ETB', value: 'ETB' },
  { id: 'FJD', label: 'FJD', value: 'FJD' },
  { id: 'FKP', label: 'FKP', value: 'FKP' },
  { id: 'FOK', label: 'FOK', value: 'FOK' },
  { id: 'GEL', label: 'GEL', value: 'GEL' },
  { id: 'GHS', label: 'GHS', value: 'GHS' },
  { id: 'GIP', label: 'GIP', value: 'GIP' },
  { id: 'GMD', label: 'GMD', value: 'GMD' },
  { id: 'GNF', label: 'GNF', value: 'GNF' },
  { id: 'GTQ', label: 'GTQ', value: 'GTQ' },
  { id: 'GYD', label: 'GYD', value: 'GYD' },
  { id: 'HKD', label: 'HKD', value: 'HKD' },
  { id: 'HNL', label: 'HNL', value: 'HNL' },
  { id: 'HRK', label: 'HRK', value: 'HRK' },
  { id: 'HTG', label: 'HTG', value: 'HTG' },
  { id: 'HUF', label: 'HUF', value: 'HUF' },
  { id: 'IDR', label: 'IDR', value: 'IDR' },
  { id: 'ILS', label: 'ILS', value: 'ILS' },
  { id: 'INR', label: 'INR', value: 'INR' },
  { id: 'IQD', label: 'IQD', value: 'IQD' },
  { id: 'IRR', label: 'IRR', value: 'IRR' },
  { id: 'ISK', label: 'ISK', value: 'ISK' },
  { id: 'JEP', label: 'JEP', value: 'JEP' },
  { id: 'JMD', label: 'JMD', value: 'JMD' },
  { id: 'JOD', label: 'JOD', value: 'JOD' },
  { id: 'JPY', label: 'JPY', value: 'JPY' },
  { id: 'KES', label: 'KES', value: 'KES' },
  { id: 'KGS', label: 'KGS', value: 'KGS' },
  { id: 'KHR', label: 'KHR', value: 'KHR' },
  { id: 'KID', label: 'KID', value: 'KID' },
  { id: 'KMF', label: 'KMF', value: 'KMF' },
  { id: 'KPW', label: 'KPW', value: 'KPW' },
  { id: 'KRW', label: 'KRW', value: 'KRW' },
  { id: 'KWD', label: 'KWD', value: 'KWD' },
  { id: 'KYD', label: 'KYD', value: 'KYD' },
  { id: 'KZT', label: 'KZT', value: 'KZT' },
  { id: 'LAK', label: 'LAK', value: 'LAK' },
  { id: 'LBP', label: 'LBP', value: 'LBP' },
  { id: 'LKR', label: 'LKR', value: 'LKR' },
  { id: 'LRD', label: 'LRD', value: 'LRD' },
  { id: 'LSL', label: 'LSL', value: 'LSL' },
  { id: 'LYD', label: 'LYD', value: 'LYD' },
  { id: 'MAD', label: 'MAD', value: 'MAD' },
  { id: 'MDL', label: 'MDL', value: 'MDL' },
  { id: 'MGA', label: 'MGA', value: 'MGA' },
  { id: 'MKD', label: 'MKD', value: 'MKD' },
  { id: 'MMK', label: 'MMK', value: 'MMK' },
  { id: 'MNT', label: 'MNT', value: 'MNT' },
  { id: 'MOP', label: 'MOP', value: 'MOP' },
  { id: 'MRO', label: 'MRO', value: 'MRO' },
  { id: 'MUR', label: 'MUR', value: 'MUR' },
  { id: 'MVR', label: 'MVR', value: 'MVR' },
  { id: 'MWK', label: 'MWK', value: 'MWK' },
  { id: 'MXN', label: 'MXN', value: 'MXN' },
  { id: 'MYR', label: 'MYR', value: 'MYR' },
  { id: 'MZN', label: 'MZN', value: 'MZN' },
  { id: 'NAD', label: 'NAD', value: 'NAD' },
  { id: 'NGN', label: 'NGN', value: 'NGN' },
  { id: 'NIO', label: 'NIO', value: 'NIO' },
  { id: 'NOK', label: 'NOK', value: 'NOK' },
  { id: 'NPR', label: 'NPR', value: 'NPR' },
  { id: 'NZD', label: 'NZD', value: 'NZD' },
  { id: 'OMR', label: 'OMR', value: 'OMR' },
  { id: 'PAB', label: 'PAB', value: 'PAB' },
  { id: 'PEN', label: 'PEN', value: 'PEN' },
  { id: 'PGK', label: 'PGK', value: 'PGK' },
  { id: 'PHP', label: 'PHP', value: 'PHP' },
  { id: 'PKR', label: 'PKR', value: 'PKR' },
  { id: 'PLN', label: 'PLN', value: 'PLN' },
  { id: 'PYG', label: 'PYG', value: 'PYG' },
  { id: 'QAR', label: 'QAR', value: 'QAR' },
  { id: 'RON', label: 'RON', value: 'RON' },
  { id: 'RSD', label: 'RSD', value: 'RSD' },
  { id: 'RUB', label: 'RUB', value: 'RUB' },
  { id: 'RWF', label: 'RWF', value: 'RWF' },
  { id: 'SAR', label: 'SAR', value: 'SAR' },
  { id: 'SBD', label: 'SBD', value: 'SBD' },
  { id: 'SCR', label: 'SCR', value: 'SCR' },
  { id: 'SDG', label: 'SDG', value: 'SDG' },
  { id: 'SEK', label: 'SEK', value: 'SEK' },
  { id: 'SGD', label: 'SGD', value: 'SGD' },
  { id: 'SHP', label: 'SHP', value: 'SHP' },
  { id: 'SLL', label: 'SLL', value: 'SLL' },
  { id: 'SOS', label: 'SOS', value: 'SOS' },
  { id: 'SRD', label: 'SRD', value: 'SRD' },
  { id: 'SSP', label: 'SSP', value: 'SSP' },
  { id: 'STN', label: 'STN', value: 'STN' },
  { id: 'SYP', label: 'SYP', value: 'SYP' },
  { id: 'SZL', label: 'SZL', value: 'SZL' },
  { id: 'THB', label: 'THB', value: 'THB' },
  { id: 'TJS', label: 'TJS', value: 'TJS' },
  { id: 'TMT', label: 'TMT', value: 'TMT' },
  { id: 'TND', label: 'TND', value: 'TND' },
  { id: 'TOP', label: 'TOP', value: 'TOP' },
  { id: 'TRY', label: 'TRY', value: 'TRY' },
  { id: 'TTD', label: 'TTD', value: 'TTD' },
  { id: 'TVD', label: 'TVD', value: 'TVD' },
  { id: 'TWD', label: 'TWD', value: 'TWD' },
  { id: 'TZS', label: 'TZS', value: 'TZS' },
  { id: 'UAH', label: 'UAH', value: 'UAH' },
  { id: 'UGX', label: 'UGX', value: 'UGX' },
  { id: 'UYU', label: 'UYU', value: 'UYU' },
  { id: 'UZS', label: 'UZS', value: 'UZS' },
  { id: 'VEF', label: 'VEF', value: 'VES' },
  { id: 'VND', label: 'VND', value: 'VND' },
  { id: 'VUV', label: 'VUV', value: 'VUV' },
  { id: 'WST', label: 'WST', value: 'WST' },
  { id: 'XAF', label: 'XAF', value: 'XAF' },
  { id: 'XCD', label: 'XCD', value: 'XCD' },
  { id: 'XOF', label: 'XOF', value: 'XOF' },
  { id: 'XPF', label: 'XPF', value: 'XPF' },
  { id: 'YER', label: 'YER', value: 'YER' },
  { id: 'ZAR', label: 'ZAR', value: 'ZAR' },
  { id: 'ZMW', label: 'ZMW', value: 'ZMW' },
];

export const REMOTE_LOCATION_OPTIONS = [
  {
    id: 'worldwide',
    label: 'Worldwide',
    labelText: 'Worldwide',
    value: 'worldwide',
    group: 'Regions',
  },
  {
    id: 'europe',
    label: 'Europe',
    labelText: 'Europe',
    value: 'europe',
    group: 'Regions',
  },
  {
    id: 'european',
    label: 'European Union',
    labelText: 'European Union',
    value: 'european',
    group: 'Regions',
  },
  {
    id: 'north-america',
    label: 'North America',
    labelText: 'North America',
    value: 'north-america',
    group: 'Regions',
  },
  {
    id: 'south-america',
    label: 'South America',
    labelText: 'South America',
    value: 'south-america',
    group: 'Regions',
  },
  {
    id: 'east-asia',
    label: 'East Asia',
    labelText: 'East Asia',
    value: 'east-asia',
    group: 'Regions',
  },
  {
    id: 'south-asia',
    label: 'South Asia',
    labelText: 'South Asia',
    value: 'south-asia',
    group: 'Regions',
  },
  {
    id: 'middle-east',
    label: 'Middle East',
    labelText: 'Middle East',
    value: 'middle-east',
    group: 'Regions',
  },
  {
    id: 'africa',
    label: 'Africa',
    labelText: 'Africa',
    value: 'africa',
    group: 'Regions',
  },
  {
    id: 'oceania',
    label: 'Oceania',
    labelText: 'Oceania',
    value: 'oceania',
    group: 'Regions',
  },
  // Europe
  {
    id: 'albania',
    label: 'Albania',
    labelText: 'Albania',
    value: 'albania',
    group: 'Europe',
  },
  {
    id: 'andorra',
    label: 'Andorra',
    labelText: 'Andorra',
    value: 'andorra',
    group: 'Europe',
  },
  {
    id: 'austria',
    label: 'Austria',
    labelText: 'Austria',
    value: 'austria',
    group: 'Europe',
  },
  {
    id: 'belarus',
    label: 'Belarus',
    labelText: 'Belarus',
    value: 'belarus',
    group: 'Europe',
  },
  {
    id: 'belgium',
    label: 'Belgium',
    labelText: 'Belgium',
    value: 'belgium',
    group: 'Europe',
  },
  {
    id: 'bosnia-herzegovina',
    label: 'Bosnia and Herzegovina',
    labelText: 'Bosnia and Herzegovina',
    value: 'bosnia-herzegovina',
    group: 'Europe',
  },
  {
    id: 'bulgaria',
    label: 'Bulgaria',
    labelText: 'Bulgaria',
    value: 'bulgaria',
    group: 'Europe',
  },
  {
    id: 'croatia',
    label: 'Croatia',
    labelText: 'Croatia',
    value: 'croatia',
    group: 'Europe',
  },
  {
    id: 'czech-republic',
    label: 'Czech Republic',
    labelText: 'Czech Republic',
    value: 'czech-republic',
    group: 'Europe',
  },
  {
    id: 'denmark',
    label: 'Denmark',
    labelText: 'Denmark',
    value: 'denmark',
    group: 'Europe',
  },
  {
    id: 'estonia',
    label: 'Estonia',
    labelText: 'Estonia',
    value: 'estonia',
    group: 'Europe',
  },
  {
    id: 'finland',
    label: 'Finland',
    labelText: 'Finland',
    value: 'finland',
    group: 'Europe',
  },
  {
    id: 'france',
    label: 'France',
    labelText: 'France',
    value: 'france',
    group: 'Europe',
  },
  {
    id: 'germany',
    label: 'Germany',
    labelText: 'Germany',
    value: 'germany',
    group: 'Europe',
  },
  {
    id: 'greece',
    label: 'Greece',
    labelText: 'Greece',
    value: 'greece',
    group: 'Europe',
  },
  {
    id: 'hungary',
    label: 'Hungary',
    labelText: 'Hungary',
    value: 'hungary',
    group: 'Europe',
  },
  {
    id: 'iceland',
    label: 'Iceland',
    labelText: 'Iceland',
    value: 'iceland',
    group: 'Europe',
  },
  {
    id: 'ireland',
    label: 'Ireland',
    labelText: 'Ireland',
    value: 'ireland',
    group: 'Europe',
  },
  {
    id: 'italy',
    label: 'Italy',
    labelText: 'Italy',
    value: 'italy',
    group: 'Europe',
  },
  {
    id: 'kosovo',
    label: 'Kosovo',
    labelText: 'Kosovo',
    value: 'kosovo',
    group: 'Europe',
  },
  {
    id: 'latvia',
    label: 'Latvia',
    labelText: 'Latvia',
    value: 'latvia',
    group: 'Europe',
  },
  {
    id: 'liechtenstein',
    label: 'Liechtenstein',
    labelText: 'Liechtenstein',
    value: 'liechtenstein',
    group: 'Europe',
  },
  {
    id: 'lithuania',
    label: 'Lithuania',
    labelText: 'Lithuania',
    value: 'lithuania',
    group: 'Europe',
  },
  {
    id: 'luxembourg',
    label: 'Luxembourg',
    labelText: 'Luxembourg',
    value: 'luxembourg',
    group: 'Europe',
  },
  {
    id: 'malta',
    label: 'Malta',
    labelText: 'Malta',
    value: 'malta',
    group: 'Europe',
  },
  {
    id: 'moldova',
    label: 'Moldova',
    labelText: 'Moldova',
    value: 'moldova',
    group: 'Europe',
  },
  {
    id: 'monaco',
    label: 'Monaco',
    labelText: 'Monaco',
    value: 'monaco',
    group: 'Europe',
  },
  {
    id: 'montenegro',
    label: 'Montenegro',
    labelText: 'Montenegro',
    value: 'montenegro',
    group: 'Europe',
  },
  {
    id: 'netherlands',
    label: 'Netherlands',
    labelText: 'Netherlands',
    value: 'netherlands',
    group: 'Europe',
  },
  {
    id: 'north-macedonia',
    label: 'North Macedonia',
    labelText: 'North Macedonia',
    value: 'north-macedonia',
    group: 'Europe',
  },
  {
    id: 'norway',
    label: 'Norway',
    labelText: 'Norway',
    value: 'norway',
    group: 'Europe',
  },
  {
    id: 'poland',
    label: 'Poland',
    labelText: 'Poland',
    value: 'poland',
    group: 'Europe',
  },
  {
    id: 'portugal',
    label: 'Portugal',
    labelText: 'Portugal',
    value: 'portugal',
    group: 'Europe',
  },
  {
    id: 'romania',
    label: 'Romania',
    labelText: 'Romania',
    value: 'romania',
    group: 'Europe',
  },
  {
    id: 'russia',
    label: 'Russia',
    labelText: 'Russia',
    value: 'russia',
    group: 'Europe',
  },
  {
    id: 'san-marino',
    label: 'San Marino',
    labelText: 'San Marino',
    value: 'san-marino',
    group: 'Europe',
  },
  {
    id: 'serbia',
    label: 'Serbia',
    labelText: 'Serbia',
    value: 'serbia',
    group: 'Europe',
  },
  {
    id: 'slovakia',
    label: 'Slovakia',
    labelText: 'Slovakia',
    value: 'slovakia',
    group: 'Europe',
  },
  {
    id: 'slovenia',
    label: 'Slovenia',
    labelText: 'Slovenia',
    value: 'slovenia',
    group: 'Europe',
  },
  {
    id: 'spain',
    label: 'Spain',
    labelText: 'Spain',
    value: 'spain',
    group: 'Europe',
  },
  {
    id: 'sweden',
    label: 'Sweden',
    labelText: 'Sweden',
    value: 'sweden',
    group: 'Europe',
  },
  {
    id: 'switzerland',
    label: 'Switzerland',
    labelText: 'Switzerland',
    value: 'switzerland',
    group: 'Europe',
  },
  {
    id: 'ukraine',
    label: 'Ukraine',
    labelText: 'Ukraine',
    value: 'ukraine',
    group: 'Europe',
  },
  {
    id: 'united-kingdom',
    label: 'United Kingdom',
    labelText: 'United Kingdom',
    value: 'united-kingdom',
    group: 'Europe',
  },
  {
    id: 'vatican-city',
    label: 'Vatican City',
    labelText: 'Vatican City',
    value: 'vatican-city',
    group: 'Europe',
  },
  // North America
  {
    id: 'antigua-barbuda',
    label: 'Antigua and Barbuda',
    labelText: 'Antigua and Barbuda',
    value: 'antigua-barbuda',
    group: 'North America',
  },
  {
    id: 'bahamas',
    label: 'Bahamas',
    labelText: 'Bahamas',
    value: 'bahamas',
    group: 'North America',
  },
  {
    id: 'barbados',
    label: 'Barbados',
    labelText: 'Barbados',
    value: 'barbados',
    group: 'North America',
  },
  {
    id: 'belize',
    label: 'Belize',
    labelText: 'Belize',
    value: 'belize',
    group: 'North America',
  },
  {
    id: 'canada',
    label: 'Canada',
    labelText: 'Canada',
    value: 'canada',
    group: 'North America',
  },
  {
    id: 'costa-rica',
    label: 'Costa Rica',
    labelText: 'Costa Rica',
    value: 'costa-rica',
    group: 'North America',
  },
  {
    id: 'cuba',
    label: 'Cuba',
    labelText: 'Cuba',
    value: 'cuba',
    group: 'North America',
  },
  {
    id: 'dominica',
    label: 'Dominica',
    labelText: 'Dominica',
    value: 'dominica',
    group: 'North America',
  },
  {
    id: 'dominican-republic',
    label: 'Dominican Republic',
    labelText: 'Dominican Republic',
    value: 'dominican-republic',
    group: 'North America',
  },
  {
    id: 'el-salvador',
    label: 'El Salvador',
    labelText: 'El Salvador',
    value: 'el-salvador',
    group: 'North America',
  },
  {
    id: 'grenada',
    label: 'Grenada',
    labelText: 'Grenada',
    value: 'grenada',
    group: 'North America',
  },
  {
    id: 'guatemala',
    label: 'Guatemala',
    labelText: 'Guatemala',
    value: 'guatemala',
    group: 'North America',
  },
  {
    id: 'haiti',
    label: 'Haiti',
    labelText: 'Haiti',
    value: 'haiti',
    group: 'North America',
  },
  {
    id: 'honduras',
    label: 'Honduras',
    labelText: 'Honduras',
    value: 'honduras',
    group: 'North America',
  },
  {
    id: 'jamaica',
    label: 'Jamaica',
    labelText: 'Jamaica',
    value: 'jamaica',
    group: 'North America',
  },
  {
    id: 'mexico',
    label: 'Mexico',
    labelText: 'Mexico',
    value: 'mexico',
    group: 'North America',
  },
  {
    id: 'nicaragua',
    label: 'Nicaragua',
    labelText: 'Nicaragua',
    value: 'nicaragua',
    group: 'North America',
  },
  {
    id: 'panama',
    label: 'Panama',
    labelText: 'Panama',
    value: 'panama',
    group: 'North America',
  },
  {
    id: 'saint-kitts-nevis',
    label: 'Saint Kitts and Nevis',
    labelText: 'Saint Kitts and Nevis',
    value: 'saint-kitts-nevis',
    group: 'North America',
  },
  {
    id: 'saint-lucia',
    label: 'Saint Lucia',
    labelText: 'Saint Lucia',
    value: 'saint-lucia',
    group: 'North America',
  },
  {
    id: 'saint-vincent-grenadines',
    label: 'Saint Vincent and the Grenadines',
    labelText: 'Saint Vincent and the Grenadines',
    value: 'saint-vincent-grenadines',
    group: 'North America',
  },
  {
    id: 'trinidad-tobago',
    label: 'Trinidad and Tobago',
    labelText: 'Trinidad and Tobago',
    value: 'trinidad-tobago',
    group: 'North America',
  },
  {
    id: 'united-states',
    label: 'United States',
    labelText: 'United States',
    value: 'united-states',
    group: 'North America',
  },
  // South America
  {
    id: 'argentina',
    label: 'Argentina',
    labelText: 'Argentina',
    value: 'argentina',
    group: 'South America',
  },
  {
    id: 'bolivia',
    label: 'Bolivia',
    labelText: 'Bolivia',
    value: 'bolivia',
    group: 'South America',
  },
  {
    id: 'brazil',
    label: 'Brazil',
    labelText: 'Brazil',
    value: 'brazil',
    group: 'South America',
  },
  {
    id: 'chile',
    label: 'Chile',
    labelText: 'Chile',
    value: 'chile',
    group: 'South America',
  },
  {
    id: 'colombia',
    label: 'Colombia',
    labelText: 'Colombia',
    value: 'colombia',
    group: 'South America',
  },
  {
    id: 'ecuador',
    label: 'Ecuador',
    labelText: 'Ecuador',
    value: 'ecuador',
    group: 'South America',
  },
  {
    id: 'guyana',
    label: 'Guyana',
    labelText: 'Guyana',
    value: 'guyana',
    group: 'South America',
  },
  {
    id: 'paraguay',
    label: 'Paraguay',
    labelText: 'Paraguay',
    value: 'paraguay',
    group: 'South America',
  },
  {
    id: 'peru',
    label: 'Peru',
    labelText: 'Peru',
    value: 'peru',
    group: 'South America',
  },
  {
    id: 'suriname',
    label: 'Suriname',
    labelText: 'Suriname',
    value: 'suriname',
    group: 'South America',
  },
  {
    id: 'uruguay',
    label: 'Uruguay',
    labelText: 'Uruguay',
    value: 'uruguay',
    group: 'South America',
  },
  {
    id: 'venezuela',
    label: 'Venezuela',
    labelText: 'Venezuela',
    value: 'venezuela',
    group: 'South America',
  },
  // East Asia
  {
    id: 'china',
    label: 'China',
    labelText: 'China',
    value: 'china',
    group: 'East Asia',
  },
  {
    id: 'hong-kong',
    label: 'Hong Kong',
    labelText: 'Hong Kong',
    value: 'hong-kong',
    group: 'East Asia',
  },
  {
    id: 'japan',
    label: 'Japan',
    labelText: 'Japan',
    value: 'japan',
    group: 'East Asia',
  },
  {
    id: 'macau',
    label: 'Macau',
    labelText: 'Macau',
    value: 'macau',
    group: 'East Asia',
  },
  {
    id: 'mongolia',
    label: 'Mongolia',
    labelText: 'Mongolia',
    value: 'mongolia',
    group: 'East Asia',
  },
  {
    id: 'north-korea',
    label: 'North Korea',
    labelText: 'North Korea',
    value: 'north-korea',
    group: 'East Asia',
  },
  {
    id: 'south-korea',
    label: 'South Korea',
    labelText: 'South Korea',
    value: 'south-korea',
    group: 'East Asia',
  },
  {
    id: 'taiwan',
    label: 'Taiwan',
    labelText: 'Taiwan',
    value: 'taiwan',
    group: 'East Asia',
  },
  // South Asia
  {
    id: 'afghanistan',
    label: 'Afghanistan',
    labelText: 'Afghanistan',
    value: 'afghanistan',
    group: 'South Asia',
  },
  {
    id: 'bangladesh',
    label: 'Bangladesh',
    labelText: 'Bangladesh',
    value: 'bangladesh',
    group: 'South Asia',
  },
  {
    id: 'bhutan',
    label: 'Bhutan',
    labelText: 'Bhutan',
    value: 'bhutan',
    group: 'South Asia',
  },
  {
    id: 'india',
    label: 'India',
    labelText: 'India',
    value: 'india',
    group: 'South Asia',
  },
  {
    id: 'maldives',
    label: 'Maldives',
    labelText: 'Maldives',
    value: 'maldives',
    group: 'South Asia',
  },
  {
    id: 'nepal',
    label: 'Nepal',
    labelText: 'Nepal',
    value: 'nepal',
    group: 'South Asia',
  },
  {
    id: 'pakistan',
    label: 'Pakistan',
    labelText: 'Pakistan',
    value: 'pakistan',
    group: 'South Asia',
  },
  {
    id: 'sri-lanka',
    label: 'Sri Lanka',
    labelText: 'Sri Lanka',
    value: 'sri-lanka',
    group: 'South Asia',
  },
  // Middle East
  {
    id: 'bahrain',
    label: 'Bahrain',
    labelText: 'Bahrain',
    value: 'bahrain',
    group: 'Middle East',
  },
  {
    id: 'cyprus',
    label: 'Cyprus',
    labelText: 'Cyprus',
    value: 'cyprus',
    group: 'Middle East',
  },
  {
    id: 'egypt',
    label: 'Egypt',
    labelText: 'Egypt',
    value: 'egypt',
    group: 'Middle East',
  },
  {
    id: 'iran',
    label: 'Iran',
    labelText: 'Iran',
    value: 'iran',
    group: 'Middle East',
  },
  {
    id: 'iraq',
    label: 'Iraq',
    labelText: 'Iraq',
    value: 'iraq',
    group: 'Middle East',
  },
  {
    id: 'israel',
    label: 'Israel',
    labelText: 'Israel',
    value: 'israel',
    group: 'Middle East',
  },
  {
    id: 'jordan',
    label: 'Jordan',
    labelText: 'Jordan',
    value: 'jordan',
    group: 'Middle East',
  },
  {
    id: 'kuwait',
    label: 'Kuwait',
    labelText: 'Kuwait',
    value: 'kuwait',
    group: 'Middle East',
  },
  {
    id: 'lebanon',
    label: 'Lebanon',
    labelText: 'Lebanon',
    value: 'lebanon',
    group: 'Middle East',
  },
  {
    id: 'oman',
    label: 'Oman',
    labelText: 'Oman',
    value: 'oman',
    group: 'Middle East',
  },
  {
    id: 'palestine',
    label: 'Palestine',
    labelText: 'Palestine',
    value: 'palestine',
    group: 'Middle East',
  },
  {
    id: 'qatar',
    label: 'Qatar',
    labelText: 'Qatar',
    value: 'qatar',
    group: 'Middle East',
  },
  {
    id: 'saudi-arabia',
    label: 'Saudi Arabia',
    labelText: 'Saudi Arabia',
    value: 'saudi-arabia',
    group: 'Middle East',
  },
  {
    id: 'syria',
    label: 'Syria',
    labelText: 'Syria',
    value: 'syria',
    group: 'Middle East',
  },
  {
    id: 'turkey',
    label: 'Turkey',
    labelText: 'Turkey',
    value: 'turkey',
    group: 'Middle East',
  },
  {
    id: 'united-arab-emirates',
    label: 'United Arab Emirates',
    labelText: 'United Arab Emirates',
    value: 'united-arab-emirates',
    group: 'Middle East',
  },
  {
    id: 'yemen',
    label: 'Yemen',
    labelText: 'Yemen',
    value: 'yemen',
    group: 'Middle East',
  },
  // Africa
  {
    id: 'algeria',
    label: 'Algeria',
    labelText: 'Algeria',
    value: 'algeria',
    group: 'Africa',
  },
  {
    id: 'angola',
    label: 'Angola',
    labelText: 'Angola',
    value: 'angola',
    group: 'Africa',
  },
  {
    id: 'benin',
    label: 'Benin',
    labelText: 'Benin',
    value: 'benin',
    group: 'Africa',
  },
  {
    id: 'botswana',
    label: 'Botswana',
    labelText: 'Botswana',
    value: 'botswana',
    group: 'Africa',
  },
  {
    id: 'burkina-faso',
    label: 'Burkina Faso',
    labelText: 'Burkina Faso',
    value: 'burkina-faso',
    group: 'Africa',
  },
  {
    id: 'burundi',
    label: 'Burundi',
    labelText: 'Burundi',
    value: 'burundi',
    group: 'Africa',
  },
  {
    id: 'cameroon',
    label: 'Cameroon',
    labelText: 'Cameroon',
    value: 'cameroon',
    group: 'Africa',
  },
  {
    id: 'cape-verde',
    label: 'Cape Verde',
    labelText: 'Cape Verde',
    value: 'cape-verde',
    group: 'Africa',
  },
  {
    id: 'central-african-republic',
    label: 'Central African Republic',
    labelText: 'Central African Republic',
    value: 'central-african-republic',
    group: 'Africa',
  },
  {
    id: 'chad',
    label: 'Chad',
    labelText: 'Chad',
    value: 'chad',
    group: 'Africa',
  },
  {
    id: 'comoros',
    label: 'Comoros',
    labelText: 'Comoros',
    value: 'comoros',
    group: 'Africa',
  },
  {
    id: 'congo',
    label: 'Congo',
    labelText: 'Congo',
    value: 'congo',
    group: 'Africa',
  },
  {
    id: 'cote-divoire',
    label: "Côte d'Ivoire",
    labelText: "Côte d'Ivoire",
    value: 'cote-divoire',
    group: 'Africa',
  },
  {
    id: 'djibouti',
    label: 'Djibouti',
    labelText: 'Djibouti',
    value: 'djibouti',
    group: 'Africa',
  },
  {
    id: 'equatorial-guinea',
    label: 'Equatorial Guinea',
    labelText: 'Equatorial Guinea',
    value: 'equatorial-guinea',
    group: 'Africa',
  },
  {
    id: 'eritrea',
    label: 'Eritrea',
    labelText: 'Eritrea',
    value: 'eritrea',
    group: 'Africa',
  },
  {
    id: 'ethiopia',
    label: 'Ethiopia',
    labelText: 'Ethiopia',
    value: 'ethiopia',
    group: 'Africa',
  },
  {
    id: 'gabon',
    label: 'Gabon',
    labelText: 'Gabon',
    value: 'gabon',
    group: 'Africa',
  },
  {
    id: 'gambia',
    label: 'Gambia',
    labelText: 'Gambia',
    value: 'gambia',
    group: 'Africa',
  },
  {
    id: 'ghana',
    label: 'Ghana',
    labelText: 'Ghana',
    value: 'ghana',
    group: 'Africa',
  },
  {
    id: 'guinea',
    label: 'Guinea',
    labelText: 'Guinea',
    value: 'guinea',
    group: 'Africa',
  },
  {
    id: 'guinea-bissau',
    label: 'Guinea-Bissau',
    labelText: 'Guinea-Bissau',
    value: 'guinea-bissau',
    group: 'Africa',
  },
  {
    id: 'kenya',
    label: 'Kenya',
    labelText: 'Kenya',
    value: 'kenya',
    group: 'Africa',
  },
  {
    id: 'lesotho',
    label: 'Lesotho',
    labelText: 'Lesotho',
    value: 'lesotho',
    group: 'Africa',
  },
  {
    id: 'liberia',
    label: 'Liberia',
    labelText: 'Liberia',
    value: 'liberia',
    group: 'Africa',
  },
  {
    id: 'libya',
    label: 'Libya',
    labelText: 'Libya',
    value: 'libya',
    group: 'Africa',
  },
  {
    id: 'madagascar',
    label: 'Madagascar',
    labelText: 'Madagascar',
    value: 'madagascar',
    group: 'Africa',
  },
  {
    id: 'malawi',
    label: 'Malawi',
    labelText: 'Malawi',
    value: 'malawi',
    group: 'Africa',
  },
  {
    id: 'mali',
    label: 'Mali',
    labelText: 'Mali',
    value: 'mali',
    group: 'Africa',
  },
  {
    id: 'mauritania',
    label: 'Mauritania',
    labelText: 'Mauritania',
    value: 'mauritania',
    group: 'Africa',
  },
  {
    id: 'mauritius',
    label: 'Mauritius',
    labelText: 'Mauritius',
    value: 'mauritius',
    group: 'Africa',
  },
  {
    id: 'morocco',
    label: 'Morocco',
    labelText: 'Morocco',
    value: 'morocco',
    group: 'Africa',
  },
  {
    id: 'mozambique',
    label: 'Mozambique',
    labelText: 'Mozambique',
    value: 'mozambique',
    group: 'Africa',
  },
  {
    id: 'namibia',
    label: 'Namibia',
    labelText: 'Namibia',
    value: 'namibia',
    group: 'Africa',
  },
  {
    id: 'niger',
    label: 'Niger',
    labelText: 'Niger',
    value: 'niger',
    group: 'Africa',
  },
  {
    id: 'nigeria',
    label: 'Nigeria',
    labelText: 'Nigeria',
    value: 'nigeria',
    group: 'Africa',
  },
  {
    id: 'rwanda',
    label: 'Rwanda',
    labelText: 'Rwanda',
    value: 'rwanda',
    group: 'Africa',
  },
  {
    id: 'sao-tome-principe',
    label: 'São Tomé and Príncipe',
    labelText: 'São Tomé and Príncipe',
    value: 'sao-tome-principe',
    group: 'Africa',
  },
  {
    id: 'senegal',
    label: 'Senegal',
    labelText: 'Senegal',
    value: 'senegal',
    group: 'Africa',
  },
  {
    id: 'seychelles',
    label: 'Seychelles',
    labelText: 'Seychelles',
    value: 'seychelles',
    group: 'Africa',
  },
  {
    id: 'sierra-leone',
    label: 'Sierra Leone',
    labelText: 'Sierra Leone',
    value: 'sierra-leone',
    group: 'Africa',
  },
  {
    id: 'somalia',
    label: 'Somalia',
    labelText: 'Somalia',
    value: 'somalia',
    group: 'Africa',
  },
  {
    id: 'south-africa',
    label: 'South Africa',
    labelText: 'South Africa',
    value: 'south-africa',
    group: 'Africa',
  },
  {
    id: 'south-sudan',
    label: 'South Sudan',
    labelText: 'South Sudan',
    value: 'south-sudan',
    group: 'Africa',
  },
  {
    id: 'sudan',
    label: 'Sudan',
    labelText: 'Sudan',
    value: 'sudan',
    group: 'Africa',
  },
  {
    id: 'swaziland',
    label: 'Swaziland',
    labelText: 'Swaziland',
    value: 'swaziland',
    group: 'Africa',
  },
  {
    id: 'tanzania',
    label: 'Tanzania',
    labelText: 'Tanzania',
    value: 'tanzania',
    group: 'Africa',
  },
  {
    id: 'togo',
    label: 'Togo',
    labelText: 'Togo',
    value: 'togo',
    group: 'Africa',
  },
  {
    id: 'tunisia',
    label: 'Tunisia',
    labelText: 'Tunisia',
    value: 'tunisia',
    group: 'Africa',
  },
  {
    id: 'uganda',
    label: 'Uganda',
    labelText: 'Uganda',
    value: 'uganda',
    group: 'Africa',
  },
  {
    id: 'zambia',
    label: 'Zambia',
    labelText: 'Zambia',
    value: 'zambia',
    group: 'Africa',
  },
  {
    id: 'zimbabwe',
    label: 'Zimbabwe',
    labelText: 'Zimbabwe',
    value: 'zimbabwe',
    group: 'Africa',
  },
  // Oceania
  {
    id: 'australia',
    label: 'Australia',
    labelText: 'Australia',
    value: 'australia',
    group: 'Oceania',
  },
  {
    id: 'fiji',
    label: 'Fiji',
    labelText: 'Fiji',
    value: 'fiji',
    group: 'Oceania',
  },
  {
    id: 'kiribati',
    label: 'Kiribati',
    labelText: 'Kiribati',
    value: 'kiribati',
    group: 'Oceania',
  },
  {
    id: 'marshall-islands',
    label: 'Marshall Islands',
    labelText: 'Marshall Islands',
    value: 'marshall-islands',
    group: 'Oceania',
  },
  {
    id: 'micronesia',
    label: 'Micronesia',
    labelText: 'Micronesia',
    value: 'micronesia',
    group: 'Oceania',
  },
  {
    id: 'nauru',
    label: 'Nauru',
    labelText: 'Nauru',
    value: 'nauru',
    group: 'Oceania',
  },
  {
    id: 'new-zealand',
    label: 'New Zealand',
    labelText: 'New Zealand',
    value: 'new-zealand',
    group: 'Oceania',
  },
  {
    id: 'palau',
    label: 'Palau',
    labelText: 'Palau',
    value: 'palau',
    group: 'Oceania',
  },
  {
    id: 'papua-new-guinea',
    label: 'Papua New Guinea',
    labelText: 'Papua New Guinea',
    value: 'papua-new-guinea',
    group: 'Oceania',
  },
  {
    id: 'samoa',
    label: 'Samoa',
    labelText: 'Samoa',
    value: 'samoa',
    group: 'Oceania',
  },
  {
    id: 'solomon-islands',
    label: 'Solomon Islands',
    labelText: 'Solomon Islands',
    value: 'solomon-islands',
    group: 'Oceania',
  },
  {
    id: 'tonga',
    label: 'Tonga',
    labelText: 'Tonga',
    value: 'tonga',
    group: 'Oceania',
  },
  {
    id: 'tuvalu',
    label: 'Tuvalu',
    labelText: 'Tuvalu',
    value: 'tuvalu',
    group: 'Oceania',
  },
  {
    id: 'vanuatu',
    label: 'Vanuatu',
    labelText: 'Vanuatu',
    value: 'vanuatu',
    group: 'Oceania',
  },
];

export const validationJobDescriptionSchema = object().shape({
  jobTitle: string().required('Please provide a job title!'),
  description: string()
    .required('Please provide a job description!')
    .max(
      9000,
      'Character limit reached. Please try shortening the page content!'
    ),
  employmentType: string(),
  department: string().max(
    300,
    'Character limit reached. Please try shortening the department name!'
  ),
  workplaceType: mixed().nullable(),
  salaryCurrency: string(),
  salaryMin: mixed()
    .nullable()
    .test(
      'positive-if-number',
      'Minimum salary must be a positive number',
      function (value) {
        if (value === null || value === undefined) return true;
        return typeof value === 'number' && value > 0;
      }
    )
    .test(
      'min-max',
      'Minimum salary must be less than maximum',
      function (value) {
        const { salaryMax } = this.parent;
        if (
          value === null ||
          value === undefined ||
          salaryMax === null ||
          salaryMax === undefined
        )
          return true;
        return (
          typeof value === 'number' &&
          typeof salaryMax === 'number' &&
          value < salaryMax
        );
      }
    ),
  salaryMax: mixed()
    .nullable()
    .test(
      'positive-if-number',
      'Maximum salary must be a positive number',
      function (value) {
        if (value === null || value === undefined) return true;
        return typeof value === 'number' && value > 0;
      }
    )
    .test(
      'max-min',
      'Maximum salary must be greater than minimum',
      function (value) {
        const { salaryMin } = this.parent;
        if (
          value === null ||
          value === undefined ||
          salaryMin === null ||
          salaryMin === undefined
        )
          return true;
        return (
          typeof value === 'number' &&
          typeof salaryMin === 'number' &&
          value > salaryMin
        );
      }
    ),
  locationAreas: array()
    .of(string())
    .test(
      'required-if-remote',
      'Please select at least one employee location',
      function (value) {
        const { workplaceType } = this.parent;

        if (workplaceType === TWorkplaceType.Remote) {
          return Array.isArray(value) && value.length > 0;
        }
        return true;
      }
    ),
  locationCity: string().test(
    'required-if-not-remote',
    'Please select an office location',
    function (value) {
      const { workplaceType } = this.parent;

      if (
        workplaceType === TWorkplaceType.Hybrid ||
        workplaceType === TWorkplaceType.Onsite
      ) {
        return typeof value === 'string' && value.length > 0;
      }
      return true;
    }
  ),
});
